import { inject, provide } from 'vue'

import useBaseModal from '@/composables/base/modal/useBaseModal'
import useBreakpoints from '@/composables/common/useBreakpoints'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useBaseConfirmModal<T = any> (key: symbol) {
  const { isDesktopSize } = useBreakpoints()

  const mainModal = useBaseModal<T>(
    key,
    {
      position: isDesktopSize.value ? 'top' : 'center'
    }
  )

  return mainModal
}

export default function useConfirmModal<T> (arg1?: symbol): ReturnType<typeof useBaseConfirmModal<T>> {
  const key = typeof arg1 === 'symbol' ? arg1 : Symbol('base-confirm-modal')
  const result = inject<ReturnType<typeof useBaseConfirmModal<T>> | undefined>(key, undefined)

  if (result === undefined) {
    const newResult = useBaseConfirmModal<T>(key)
    provide(key, newResult)
    return newResult
  }

  return result
}
